import React,{useEffect} from "react";
import './VerifiedArtist.css'
import VerifiedArtistImg2 from './../../../../images/verifiedartistimg2.png'
import VerifySocialSquare from './../../../../images/verifysocialsquare.png'
import VerifyLinkArrow from './../../../../images/verifylinkarrow.png'
import {useLocation,useNavigate} from "react-router-dom";
import backbtn from './../../../../images/backicon.png'
import { useJwt, decodeToken } from "react-jwt";
import Cookies from 'universal-cookie';

function VerifiedArtist() {
    const navigate = useNavigate();
    const cookies = new Cookies(null ,{ path: '/' });

    // function topFunction() {
    //     document.body.scrollTop = 0; // For Safari
    //     document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    //   }
    
    useEffect(()=>{
        // topFunction()
    },[])

    
    return (
        <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}>
         
            <div onClick={()=>{
                    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                        navigate("/Dashboard/promoteyourself")
                      }
      
                      if(decodeToken(cookies.get('token')).info.role==="label"){
                        navigate("/dashboard/label/promoteartist")
                      }
                }} className="VABackBtn" style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',cursor:'pointer',alignSelf:'flex-start',width:'9.6em',border:'1px solid #FFFFFF',borderRadius:'2px',paddingTop:'0.75em',paddingBottom:'0.75em',marginTop:'5em'}}>
                  <img src={backbtn}/>
                  <div className="BackBtnTxt">Back</div>
            </div>
            <div className="VerifiedArtistH1">Get “Verified Artist” Status</div>
            <div className="VerifiedArtistH2">Become the Official Artist: Boost Credibility, Searchability, and Unlock Exclusive Benefits</div>
            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/zcgilwrctug9qaxo1rvh"} style={{width:'100%',marginTop:'2.5em'}}/>

            <div style={{display:"flex",flexDirection:'row',marginTop:'2.5em'}}>
                    <div className="div" style={{width:'1.05em',height:'0.125em'}}/>
                    <div className="div" style={{width:'8.31em',height:'0.125em',marginLeft:'0.5em'}}/>
            </div>

            <div  className="VerifiedArtistInfo">
            Become a "verified artist" on a platform, where you'll gain official recognition and access to special features. Take advantage of profile customization and audience engagement tools designed to boost interaction with your followers.
            </div>

            <span className="VerifiedArtistTitle">
            <span style={{color:'#E91353'}}>\\</span> What’s a “Verified Artist”?
            </span>

            <div className="VerifiedArtistDesc">
            A "verified artist" on platforms like Spotify and Apple Music gains special features that enhance their presence and engagement with their audience. This status not only boosts their credibility but also provides them with tools to better connect with their fans and manage their music career.
            </div>

            <div className="VerifiedArtistDesc" style={{marginTop:'2em',width:'72%'}}>
            &#x2022;&nbsp; Profile Customization: Add a professional picture, bio, social media links, and featured content.
            </div>
            <div className="VerifiedArtistDesc" style={{marginTop:'0em',width:'72%'}}>
            &#x2022;&nbsp; Audience Engagement: Access listener analytics, send fan updates, and share exclusive content.
            </div>
            <div className="VerifiedArtistDesc" style={{marginTop:'0em',width:'72%'}}>
            &#x2022;&nbsp; Enhanced Credibility: Verification badge boosts authenticity and discoverability.
            </div>

            <img src={VerifiedArtistImg2} style={{borderRadius:'2px',width:'75.16%',marginTop:'2.5em'}}/>

            <span className="VerifiedArtistTitle">
            <span style={{color:'#E91353'}}>\\</span> Why is it important?
            </span>

            <div className="VerifiedArtistDesc">
           In the rapidly evolving music industry, independent artists often struggle to gain visibility and credibility. Various platforms addresses this challenge head-on by offering a verification status that amps up artists’ credibility, ensuring fans know it’s really them rocking the charts. <br/> <br/>
           With verification, artists can more effectively attract new fans and unlock lucrative opportunities previously reserved for those signed with big labels.  <br/> <br/>
           By providing this level of recognition, verification empowers artists to elevate their careers, ensuring they get paid and gain access to collaborations with iconic brands, thereby democratizing success in the music industry.
            </div>

            <span className="VerifiedArtistTitle">
            <span style={{color:'#E91353'}}>\\</span> What do I need in order to opt-in?
            </span>

            <div className="VerifiedArtistDesc">
            Depending on the platform, several requirements must be met for verification, including proving their own identity or affiliation with the artist or band, and having at least one official music release on the platform that has been delivered and distributed by a Music Distributor or Label. 
            </div>

            <span className="VerifiedArtistTitle">
            <span style={{color:'#E91353'}}>\\</span> Verify now
            </span>

            <div className="SocialContainer">
                <img src={VerifySocialSquare} style={{width:'2.36em',height:'2.36em',marginRight:'2em'}}/>
                <div style={{display:'flex',flexDirection:'column'}}>
                <div className="SocialTxt">
                We've compiled the verification guides for the most popular platforms below. Take a moment to verify your accounts on each one and stay ahead of the competition!
                </div>

                <a href="https://artists.spotify.com/en/blog/how-to-get-verified" target="_blank"  style={{display:'flex',flexDirection:'row',marginTop: '0.77em',cursor:'pointer'}}>
                    <div className="LinkTxt">Spotify</div>
                    <img src={VerifyLinkArrow} style={{marginLeft:'0.4em'}}/>
                </a>

                <a href="https://artists.apple.com/support/1101-claim-your-account" target="_blank"  style={{display:'flex',flexDirection:'row',marginTop: '0.77em',cursor:'pointer'}}>
                    <div className="LinkTxt">Apple Music</div>
                    <img src={VerifyLinkArrow} style={{marginLeft:'0.4em'}}/>
                </a>

                <a href="https://support.google.com/youtube/answer/7336634?hl=en" target="_blank"  style={{display:'flex',flexDirection:'row',marginTop: '0.77em',cursor:'pointer'}}>
                    <div className="LinkTxt">Youtube</div>
                    <img src={VerifyLinkArrow} style={{marginLeft:'0.4em'}}/>
                </a>
                </div>
            </div>

         </div>
    );
}

export default VerifiedArtist;